import * as $ from "jquery";
import { CookieHelper } from "../Helpers/CookieHelper";

export class Antiforgery {
    public static getAntiforgeryTokenValue(): string {
        const $jsSettings: JQuery = this.jsSettings || (this.jsSettings = $("[data-javascript-settings]"));

        if (!$jsSettings || $jsSettings.length !== 1) {
            // bridge to DLU
            return CookieHelper.getCookie("antiforgery");
        }

        return $jsSettings.data("javascript-antiforgery") as any;
    }

    public static setAntiforgeryTokenValue(value: string): void {
        const $jsSettings: JQuery = this.jsSettings || (this.jsSettings = $("[data-javascript-settings]"));

        if (!$jsSettings || $jsSettings.length !== 1) {
            return;
        }

        $jsSettings.data("javascript-antiforgery", value);
    }

    private static jsSettings = null;
}
